<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-01 17:29:07
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-01 17:29:07
-->
<template>
  <div class="news">
    <search-header />

    <div class="title-box">
      <h1>{{ data.title }}</h1>
     <!-- <div class="sub-title">
        <span style="margin-right: 20px">发文日期：{{ data.createTime }}</span>
        <span>区域: {{ data.areaCode }}</span>
        <span>行业: {{ data.industryCode }}</span>
      </div>
      <div class="sub-title">
        <span>地址: {{ data.areaCode }}/{{ data.park }}/{{ data.address }}</span>
        <span>受助主题: {{ data.aidedTheme }}</span>
        <span>执行方式: {{ data.mode }}</span>
      </div>-->
    </div>

    <div class="content">
      <!-- 富文本方式 -->
      <div v-html="data.content"></div>

      <div v-if="files && files.length" class="download">
        <div>附件：</div>
        <div class="file-list">
          <a
            v-for="item in imgsfiles"
            :key="item.id"
            :href="item"
            >附件</a
          >
        </div>
      </div>
    </div>

    <div class="content">
      <div class="download" style="display:inline">
        <div><p>申报信息：请按照要求逐个上传已经准备好的资料</p></div>
        <div class="file-list">
          <a-form-model
            v-model="form"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 24 }"
          >
            <!--<a-form-model-item label="">
              <a-input v-model="form.concat" placeholder="联系人" />
            </a-form-model-item>
            <a-form-model-item label="">
              <a-input v-model="form.phone" placeholder="联系电话" />
            </a-form-model-item>
            <a-form-model-item label="">
              <a-input v-model="form.email" placeholder="电子邮箱" />
            </a-form-model-item>-->
            <a-form-model-item label="">
              <a-upload
                :locale="locale"
                :showUploadList="true"
                name="file"
                action="/newapp/api/common/attachment"
                @change="handleChange"
              >
            
                <p><a-button> <a-icon type="upload" /> 上传 </a-button></p>
              </a-upload>
            </a-form-model-item>
             <a-popconfirm title="请确认资料是否上传完整，然后再提交?" @confirm="() => tiiao()"  okText="确定" cancelText="取消">
                <a-button type="primary" @click="tiiao()">提交</a-button>
            </a-popconfirm>
           
          </a-form-model>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import request from "../util/request";
import qs from "qs";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  
  data() {
    return {
      locale,
      form: {},
      imgsfiles: [],
      html: "<div>123</div>",
      data: {},
      files: [
        { url: "https://www.baidu.com", name: "附件1" },
        { url: "213", name: "附件2" },
      ],
    };
  },
  mounted() {
    let id = this.$route.query.id;

    console.log(id);
    this.form.shenId = id;
    this.quertDetail(id);
  
  },
  methods: {
    handleChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        console.log(info.fileList);

        this.form.fileId = [];
        // this.form.fileId = this.form.fileId+","+info.file.response.data.url;
        for (var i = 0; i < info.fileList.length; i++) {
          console.log(info.fileList[i]);
          this.form.fileId.push(info.fileList[i].response.data.url);
        }
        console.log(this.form.fileId);
        this.$message.success(`${info.file.name} 文件上传成功`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败`);
      }
    },
    tiiao() {
      const that = this;
        if (!this.$parent.isLogin) {
    
          that.$router.push({path:"/login",query:{url:location.hash}});
  
        }else{
          if (this.form.fileId.length == 0) {
            this.$message.error("请上传附件");
          } else {
            this.form.fileId = this.form.fileId.join(",");
            request({
              url: "/api/client/common/shen",
              method: "post",
              data: qs.stringify(this.form),
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }).then((res) => {
              if (res.code == "200") {
                this.$message.success("提交成功");
                this.form = {};
                this.$router.push({path:"/shen"})
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        }
    },
    quertDetail(id) {
      this.form.fileId = [];
      request({
        url: "/api/client/common/shen/detail/" + id,
        method: "get",
      }).then((res) => {
        if (res.code == "200") {
          this.data = res.data;
          this.imgsfiles = this.data.fileIds;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.news {
  .title-box {
    width: 1280px;
 
    margin: 20px auto;
    padding: 20px;
    justify-content: center;
    background: #fff;
    h1 {
      text-align: center;
    }
    .sub-title {
      margin: 20px auto;
      color: #999;
      width: 800px;
      display: flex;
      justify-content: space-around;
    }
  }
  .content {
    width: 1280px;
    margin: 20px auto;
    padding: 20px 100px;
    background: #fff;
  }
  .download {
    display: flex;
    .file-list {
      display: flex;
      flex-direction: column;
      a {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
